const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
const desktopPreference = window.matchMedia('(min-width: 750px)');
const initializedReveals = new WeakSet();
const initializedVideos = new WeakSet();

document.documentElement.classList.add('qg-motion-ready');

function show(element) {
  element.classList.add('is-visible');
}

function initializeReveals(root = document) {
  const elements = root.querySelectorAll('[data-qg-reveal]');

  if (motionPreference.matches || !('IntersectionObserver' in window)) {
    elements.forEach(show);
    return;
  }

  const loadElements = root.querySelectorAll('[data-qg-reveal-load]');
  requestAnimationFrame(() => loadElements.forEach(show));

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        show(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
  );

  elements.forEach((element) => {
    if (initializedReveals.has(element)) return;
    initializedReveals.add(element);

    if (element.hasAttribute('data-qg-reveal-load')) return;
    observer.observe(element);
  });
}

function initializeVideos(root = document) {
  const videos = root.querySelectorAll('.qg-science__video');

  videos.forEach((video) => {
    if (initializedVideos.has(video)) return;
    initializedVideos.add(video);

    if (motionPreference.matches || !desktopPreference.matches || !('IntersectionObserver' in window)) {
      video.pause();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !motionPreference.matches && desktopPreference.matches) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { rootMargin: '120px 0px', threshold: 0.2 }
    );

    observer.observe(video);
  });
}

function initialize(root = document) {
  initializeReveals(root);
  initializeVideos(root);
}

function disableMotion() {
  document.querySelectorAll('[data-qg-reveal]').forEach(show);
  document.querySelectorAll('.qg-science__video').forEach((video) => video.pause());
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
} else {
  initialize();
}

document.addEventListener('shopify:section:load', (event) => initialize(event.target));
motionPreference.addEventListener('change', (event) => {
  if (event.matches) disableMotion();
});
desktopPreference.addEventListener('change', (event) => {
  if (!event.matches) document.querySelectorAll('.qg-science__video').forEach((video) => video.pause());
});
